import { OverSpent, OverSpentColorEnum, overSpentConstructDonuts } from "@/models/consumption/over-spent"
import { percentageHelper } from "@/mega-ui/helpers/function"
import { OverSpentTypeEnum } from "@/enums"

const internationalData = (data: OverSpent, overSpentBalance: number): overSpentConstructDonuts => {
    return {
        key: OverSpentTypeEnum.International,
        backgroundColor: [OverSpentColorEnum.international, OverSpentColorEnum.neutre],
        data: [percentageHelper(data.international, overSpentBalance), 100],
        base: data
    }
}

const roamingData = (data: OverSpent, overSpentBalance: number): overSpentConstructDonuts => {
    return {
        key: OverSpentTypeEnum.Roaming,
        backgroundColor: [OverSpentColorEnum.roaming, OverSpentColorEnum.neutre],
        data: [percentageHelper(data.roaming, overSpentBalance), 100],
        base: data
    }
}

const nationalData = (data: OverSpent, overSpentBalance: number): overSpentConstructDonuts => {
    return {
        key: OverSpentTypeEnum.National,
        backgroundColor: [OverSpentColorEnum.national, OverSpentColorEnum.neutre],
        data: [percentageHelper(data.national, overSpentBalance), 100],
        base: data
    }
}

// eslint-disable-next-line
const overSpentList: any = {
    [OverSpentTypeEnum.International]: internationalData,
    [OverSpentTypeEnum.Roaming]: roamingData,
    [OverSpentTypeEnum.National]: nationalData
};

export const overSpentDataConstruction = (item: OverSpentTypeEnum, data: OverSpent, overSpentBalance: number): overSpentConstructDonuts | null => {
    if (!item || !data) {
        return null;
    }
    
    return overSpentList[item](data, overSpentBalance) || null;
}
